<template>
  <!-- 预览（包括表单和模板渲染，支持左右联动）
         @author liuguisheng
         @date 2019-9-14  
  -->
  <div class="dialog-preview">
    <!-- 预览为空 -->
    <div v-if="showEmptyContent" class="preview-enpty">暂无内容</div>
    <!-- 预览内容 -->
    <div class="preview-main" v-else>
      <div class="preview-main_left">
        <!-- 填写表单 -->
        <rice-preview-form
          ref="previewForm"
          v-model="formModels"
          :formData="_formDatas"
          :startNonius="true"
          :toggleClearModel="toggleClearModel"
          @firstElement="firstElement = arguments[0]"
          @getUpdateData="onFormChange"
        >
        </rice-preview-form>
      </div>
      <!-- 中间分隔线 -->
      <div class="preview-main_line"></div>
      <!-- 打印预览表单 -->
      <div class="preview-main_right">
        <rice-preview-render
          v-model="formModels"
          :formData="_formDatas"
          :scrollPosition="firstElement"
        >
        </rice-preview-render>
      </div>
    </div>
  </div>
</template>
<script>
/** 混入方法 :::
 *  @mixins mixRicePreviewBridgeStore 联动预览状态数据
 */
import { mixRicePreviewBridgeStore } from "@/mixins/rice_preview_bridge/mix_rice_preview_bridge.js";
/** 工具方法 :::
 *  @function upgrade 配置升级方法
 */
import { upgrade } from "@/assets/version/version.js";

/** @name 表单预览组件
 *  @param {Object} formModel 表单填写数据
 *  @param {Object} formData 表单模版相关数据
 *    - {Array} domainList 领域模版列表
 *    - {Array} formList 表单项模版列表
 *    - {Object} eventMap 事件字典数据
 *  @function validate 对整个表单内容进行校验
 */
export default {
  name: "RicePreviewBridge",
  mixins: [mixRicePreviewBridgeStore],
  model: {
    prop: "formModel",
    event: "refurbishModel",
  },
  props: {
    // // 表单填写数据
    formModel: {
      type: Object,
      default: () => ({})
    },
    // 表单数据
    formData: {
      type: Object,
      default: () => ({})
    },
    // 切换清空model
    toggleClearModel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      itemManage: "none", // 模版类型  { 'group':启用分组的模版 }
      inputList: [], // 输入元素列表
      renderMap: {}, // 预览元素字典
      inputWrapElement: null, // 输入元素容器
      renderWrapElement: null, // 预览元素容器
      renderShow: false, // 打印预览表单显示标记
      renderLoading: true, // 打印预览渲染loading
      _formDatas: {}, // 表单模板数据
      firstElement: "", // 填写区第一个可视元素
    };
  },
  methods: {
    /** @name 对整个表单进行校验
     *  @author 王汝鹏
     *  @version 2019-12-18
     */
    validate() {
      return this.$refs["previewForm"].validate();
    },
    onFormChange(newFormDatas) {
      this._formDatas = newFormDatas;
      this.$emit("getUpdateData", newFormDatas);
    },
  },
  computed: {
    /** @name 空展示列表
     *  @return {Boolean} {true:显示空内容，false:显示表单内容}
     *  @author 王汝鹏
     *  @version 2019-12-27
     */
    showEmptyContent() {
      let {
        itemManage = "group",
        domainList = [],
        formList = [],
        formMap = {},
        eventMap = {},
        variableMap = {},
      } = this.formData;
      let domainNodeList = domainList.map((domain) =>
        this.domainManager(domain).getNode()
      );
      return itemManage === "group"
        ? domainNodeList.length === 0 && formList.length === 0
        : formList.length === 0;
    },
    /** @name 表单填写数据
     *  @return {Object} 表单填写数据
     *  @author 王汝鹏
     *  @version 2020-01-16
     */
    formModels: {
      get() {
        return this.formModel;
      },
      set(newValue) {
        this.$emit("refurbishModel", newValue);
      },
    },
    /** @name 表单模板数据
     *  @return {Object} 表单模板数据
     *  @author 王汝鹏
     *  @version 2020-01-16
     */
    // formDatas: {
    //   get() { return this._formDatas = this.formData; },
    //   set(newValue) {
    //     this._formDatas = newValue;
    //     this.$emit("getUpdateData", newValue);
    //   }
    // }
  },
  watch: {
    formData: {
      handler(newValue) {
        this._formDatas = newValue;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // 填写表单渲染完成后，再去渲染打印预览表单，避免填写表单渲染过程中事件处理造成数据变化引起打印预览表单跟着重复渲染
    setTimeout(() => {
      this.renderShow = true;
    }, 20);
  },
};
</script>
<style lang="scss">
@import "../../../src/style/index.scss";
</style>


// WEBPACK FOOTER //
// packages/RicePreviewBridge/src/RicePreviewBridge.vue